import React from "react";

function TermsPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        padding: "32px"
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          background: "#fff",
          borderRadius: "20px",
          padding: "24px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.08)"
        }}
      >
        <h1>Terms of Use</h1>

        <p style={{ color: "#6b7280" }}>
          View or download the official Ecovanta / Onedigitale Terms of Use.
        </p>

        <div style={{ marginBottom: "16px" }}>
          <a href="/legal/terms-of-use.pdf" target="_blank" rel="noreferrer">
            Open PDF in new tab
          </a>
          {" • "}
          <a href="/legal/terms-of-use.pdf" download>
            Download PDF
          </a>
        </div>

        <iframe
          src="/legal/terms-of-use.pdf"
          title="Terms of Use"
          style={{
            width: "100%",
            height: "80vh",
            border: "1px solid #e5e7eb",
            borderRadius: "12px"
          }}
        />

        <div style={{ marginTop: "24px" }}>
          <a href="/">← Back to Ecovanta</a>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;